import { t } from "i18next"
import theme from "utils/themeVars"

const mortgageAssessmentTransformer = data => {
  const response = data?.snapshot ? data?.snapshot : data
  const netLoanCoverage = response?.netLoanCoverage || response?.snapshot?.netLoanCoverage || "0"
  const getCoverageStatus = coverage => {
    if (coverage > 99) return "high"
    if (coverage >= 70 && coverage < 100) return "medium"
    if (coverage < 70) return "low"
    return "default"
  }

  const status = getCoverageStatus(netLoanCoverage)

  const loanBreakdownColorMap = {
    high: "#009F2B05",
    medium: "#FAFDFE",
    low: "#FFFBFB",
  }

  const dataColor = {
    high: theme["primary-color"],
    medium: theme["accent-color"],
    low: theme["error-color"],
  }

  const eligibilityColorMap = {
    high: "#EDF8F0",
    medium: "#EFF8FC",
    low: "#FEF2F2",
  }

  const iconMap = {
    high: "BsCheckCircleFill",
    medium: "BsFillQuestionCircleFill",
    low: "MdCancel",
  }

  const eligibilityText = {
    high: t("Eligible"),
    medium: t("Possibly Eligible"),
    low: t("Not Eligible"),
  }

  const mortgageSummaryColors = {
    eligibilityColor: eligibilityColorMap[status],
    loanbreakDownColor: loanBreakdownColorMap[status],
  }

  const eligibleInfoBlock = [
    {
      data: iconMap[status],
      label: eligibilityText[status],
      type: "iconComponent",
      isComponent: true,
      dataColor: dataColor[status],
    },
    {
      data: response?.netLoanAmount || "0",
      label: t("Eligibility"),
      type: "numberComponent",
      isComponent: true,
      dataColor: dataColor[status],
    },
    {
      data: response?.loanAmountRequired || "0",
      label: t("Required Amount"),
      type: "numberComponent",
      isComponent: true,
      dataColor: dataColor[status],
    },
    {
      data: netLoanCoverage,
      label: t("Eligibility Coverage"),
      type: "percentageComponent",
      isComponent: true,
      dataColor: dataColor[status],
    },
  ]

  const loanInfoBlock = [
    {
      data: ((response?.interestRateToApply || 0) * 100).toString() || "0",
      label: t("Interest Rate"),
      type: "percentageComponent",
      isComponent: true,
    },
    {
      data: response?.dealPrice.toString() || "0",
      label: t("Unit Price"),
      type: "numberComponent",
      isComponent: true,
    },
    {
      data:
        (data?.cdpCommitment || data?.mortgageAssessmentRecord?.cdpCommitment) *
          0.01 *
          (data?.mortgageAssessmentRecord?.snapshot?.dealPrice || response?.dealPrice?.toString()) || "0",
      label: t("Cash Contribution"),
      type: "numberComponent",
      isComponent: true,
    },
    {
      data: response?.loanAmountRequired?.toString() || "0",
      label: t("Loan Amount Required"),
      type: "numberComponent",
      isComponent: true,
    },
    {
      data: response?.totalInterestAmount?.toString() || "0",
      label: t("Interest Amount"),
      type: "numberComponent",
      isComponent: true,
    },
    {
      data: response?.totalPayback.toString() || "0",
      label: t("Total Payback"),
      type: "numberComponent",
      isComponent: true,
    },
    {
      data: response?.monthlyInstallment?.toFixed(2)?.toString() || "0",
      label: t("Monthly Installment"),
      type: "numberComponent",
      isComponent: true,
    },
  ]
  return {
    ...data,
    eligibleMonthlyInstallment: data?.eligibleMonthlyInstallment ?? data?.snapshot?.eligibleMonthlyInstallment,
    tenor: data?.mortgageAssessmentRecord?.tenor ?? data?.tenor,
    mortgageSummaryColors,
    eligibleInfoBlock,
    loanInfoBlock,
  }
}

export default mortgageAssessmentTransformer
